import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Row, Form, FormGroup, Input, Col, Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import useFetchingUnsyncedCompanies from './useFetchingUnsyncedCompanies'
import CompaniesTable from './CompaniesTable'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import { useEffect } from 'react'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const UnsyncedCompanies = (props) => {
  let pageSize = 10
  useFetchingUnsyncedCompanies()
  const [companies, setCompanies] = useState(props.unsyncedList)
  const [filteredCompanies, setfilteredCompanies] = useState(props.unsyncedList)
  const [searchCompany, setSearchCompany] = useState('')
  const [pageCount, setpageCount] = useState(null)
  const [currentPage, setCurrentPage] = useState(0)

  const handleSearchChange = (event) => {
    setSearchCompany(event.target.value)

    let filteredCompanies = companies

    if (event.target.value !== '') {
      filteredCompanies = filteredCompanies.filter((company) => {
        return company.companyName.toLowerCase().indexOf(searchCompany.toLowerCase()) !== -1
      })
    }

    setfilteredCompanies(filteredCompanies)
  }
  const firstUpdate = useRef(true)

  // useEffect and firstUpdate to only set the company and filtered state once loaded from api.
  useEffect(() => {
    if (props.unsyncedList && props.unsyncedList.length > 0) {
      if (firstUpdate.current) {
        firstUpdate.current = false
        setCompanies(props.unsyncedList)
        setfilteredCompanies(props.unsyncedList)
        let newPageCount = Math.ceil(props.unsyncedList.length / pageSize)
        setpageCount(newPageCount)
        return
      }
    }
  }, [props.unsyncedList, pageSize])

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <PageHeading>Unsynced Companies</PageHeading>
        </Row>
        <div style={{ float: 'right' }}>
          {pageCount && (
            <Pagination aria-label="Page navigation">
              <PaginationItem disabled={currentPage <= 0}>
                <PaginationLink onClick={() => setCurrentPage(currentPage - 1)} previous href="#" />
              </PaginationItem>
              {[...Array(pageCount)].map((page, i) => (
                <PaginationItem active={i === currentPage} key={i}>
                  <PaginationLink onClick={() => setCurrentPage(i)} href="#">
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={currentPage >= pageCount - 1}>
                <PaginationLink onClick={() => setCurrentPage(currentPage + 1)} next href="#" />
              </PaginationItem>
            </Pagination>
          )}
        </div>
        <Form>
          <FormGroup row>
            <Col sm={4}>
              <Input
                onChange={handleSearchChange}
                value={searchCompany}
                type="search"
                name="search"
                id="Search"
                placeholder="Search for a company"
              />
            </Col>
          </FormGroup>
        </Form>
        <CompaniesTable currentPage={currentPage} pageSize={pageSize} companies={filteredCompanies} />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loading,
  unsyncedList: state.company.unsyncedList,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(UnsyncedCompanies)
